import script from "./Signup_h5.vue?vue&type=script&lang=ts&setup=true"
export * from "./Signup_h5.vue?vue&type=script&lang=ts&setup=true"

import "./Signup_h5.vue?vue&type=style&index=0&id=9fd8fd54&lang=css"
import "./Signup_h5.vue?vue&type=style&index=1&id=9fd8fd54&lang=scss"
import "./Signup_h5.vue?vue&type=style&index=2&id=9fd8fd54&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fd8fd54"]])

export default __exports__